import { SimNaoEnum } from 'components/form'

import { hasAnySim, isAllNao, isPerguntaOutroFilled } from '../../utils-consultaSeguimento'
import {
  ConsultaSeguimentoPergunta20ExemplosEnum,
  ConsultaSeguimentoPergunta20Model,
} from './model-consultaSeguimentoPergunta20'

/* 
  Para as funções da Pergunta 20, o campo Outros preenchido é considerado como Exemplo positivo (valor Sim)
  por isso só é verificado se está preenchido
*/

const pergunta20ExemplosEnumValues = Object.values(ConsultaSeguimentoPergunta20ExemplosEnum)

export const isPergunta20ExemplosAllNao = (value: ConsultaSeguimentoPergunta20Model): boolean => {
  if (isPerguntaOutroFilled(value?.PERGUNTA_20_OUTRO)) {
    return false
  }

  return isAllNao(value?.PERGUNTA_20_EXEMPLOS, pergunta20ExemplosEnumValues)
}

export const hasPergunta20ExemplosAnySim = (value: ConsultaSeguimentoPergunta20Model): boolean => {
  return hasAnySim(value?.PERGUNTA_20_EXEMPLOS) || isPerguntaOutroFilled(value?.PERGUNTA_20_OUTRO)
}

export function prunePergunta20(value: ConsultaSeguimentoPergunta20Model): ConsultaSeguimentoPergunta20Model {
  const pruned: ConsultaSeguimentoPergunta20Model = {
    status: value.status,
    resultado: value.resultado,
    PERGUNTA_20_HEADER: value.PERGUNTA_20_HEADER,
  }

  const isHeaderSim = value.PERGUNTA_20_HEADER === SimNaoEnum.SIM
  const isHeaderNao = value.PERGUNTA_20_HEADER === SimNaoEnum.NAO
  const isGostaDePularOubalancarNao = value.PERGUNTA_20_GOSTA_DE_PULAR_OU_BALANCAR === SimNaoEnum.NAO

  const shouldShowExemplos = isHeaderNao || (isHeaderSim && isGostaDePularOubalancarNao)

  if (isHeaderSim) {
    pruned.PERGUNTA_20_GOSTA_DE_PULAR_OU_BALANCAR = value.PERGUNTA_20_GOSTA_DE_PULAR_OU_BALANCAR
  }

  if (shouldShowExemplos) {
    pruned.PERGUNTA_20_EXEMPLOS = value.PERGUNTA_20_EXEMPLOS
    pruned.PERGUNTA_20_OUTRO = value.PERGUNTA_20_OUTRO
  }

  return pruned
}
